const createTexturesState = (set) => ({
  textures: null,
  setTextures: (textures) => set({ textures: { ...textures } }),
});

export { createTexturesState };
